export default __webpack_public_path__ + "static/media/tag_grey.e9717b73.svg";